<div style="background-color: #F5F7F8; height: 89.5vh; overflow-y: scroll;  overflow-x: hidden;">
    <div style="position: relative;">
        <span (click)="this.back()" style="width: 41px;z-index: 1000;height: 41px;position: absolute;top: 18px;left: 19px;padding: 7px;border: 2px solid #E9EBF0;border-radius: 30px;">
            <img style="z-index: 1000000; width: 22px; height: 22px;" (click)="this.back()" src="/assets/images/shared/back.svg">
        </span>
        <span style="width: 41px;z-index: 1000;height: 41px;position: absolute;top: 20px;padding: 4px;right: 20px;border: 2px solid #E9EBF0;border-radius: 30px;">
            <img (click)="this.goToCart(login)" style="z-index: 1000; width: 30px; height: 30px;" src="/assets/images/product/cart-icon.svg"/>
            <span (click)="this.goToCart(login)" *ngIf="this.user && this.user.data && this.user.data.cart && this.user.data.cart.lines.length" [style]="this.getCartButtonStyle(this.user.data.cart.lines.length)">{{ this.user!.data.cart.lines.length}}</span>
        </span>
    </div>
    <div style="width: 100%; margin: auto; background-color: white; padding: 10px;">
        <ngb-carousel [interval]="0" #carouseltoggle class="carousel slide carousel-fade"  data-interval="false" data-touch="true" data-ride="carousel"  style="width: 100%; display: inline-block; height: 100%;" *ngIf="this.productImages.data.length" [showNavigationArrows]="false" [showNavigationIndicators]="true">
            <ng-template ngbSlide *ngFor="let image of this.productImages.data">
              <div class="picsum-img-wrapper">
                <img (touchstart)="posIni = $event.changedTouches[0].pageX" (touchend)="move($event.changedTouches[0].pageX, carouseltoggle)" (click)="this.onImageClick(carousel, carouseltoggleGallery, image)" [src]="image.original.url" style="width: 250px; height: 250px;" alt="Random slide">
              </div>
            </ng-template>
        </ngb-carousel>
    </div>

    <div class="product-header-box">
        <p style="font-weight: bold; width: fit-content; display: inline-block;"> {{ this.currentItem?.name }}</p>
        <div style=" width: fit-content; float: right;">
            <img (click)="this.share()" style="z-index: 1000; width: 28px; height: 28px; margin-right: 20px;" src="/assets/images/product/icon-share.svg"/>
            <img (click)="this.toggleFavourite(login)" style="z-index: 10000; width: 22px;" [src]="(this.isFavourite) ? '/assets/images/product/added-to-fav.svg' : '/assets/images/product/add-to-fav.svg'"/>
        </div>
        <div>
            <ngb-rating (click)="this.goToReviews()" [readonly]="true" style="position: relative;" [rate]="this.currentItem?.ratingAvgValue || 0" [max]="5">
                <ng-template let-fill="fill" let-index="index">
                    <span class="star" [class.filled]="fill === 100">&#9733;</span>
                </ng-template>
            </ngb-rating>
            <span style="margin-left: 5px; position: relative; top: -3px;">{{ "("+ (this.currentItem?.ratings?.data?.length ||  0) +")"}}</span>
        </div>
        <h4 style="margin-top: 2px; margin-bottom: 2px; display: inline-block;"><span [class]="this.inStock ? 'instock' : 'outstock'"> {{ this.inStock ? 'В наличност ' : 'Изчерпано ' }} </span> | <span style="color: black;">{{ this.delivery }}</span> </h4>
        <hr style="width: 90%; margin: auto; border: 1px solid #F5F7F8; opacity: 1; margin-top: 10px; margin-bottom: 10px;">
        <div class="product-price-row">
          <div class="product-price-col">
            <app-price
              *ngIf="this.currentItem?.pricing?.length"
              class="product-main-price"
              [amount]="unitPriceForSelectedQty()"
              layout="inline"
            ></app-price>

            <div class="suggested-deal" *ngIf="suggestedDeal as s">
              <app-price
                class="suggested-price"
                [amount]="s.pricePerPiece"
                layout="inline"
              ></app-price>

              <span class="suggested-text">
                {{ '/бр. за ' + s.qtyFrom + (s.isPlus ? '+' : '') + ' броя' }}
              </span>
            </div>
          </div>

          <div class="product-qty-col">
            <img
              (click)="this.decreaseAmount()"
              [class]="this.isDecreaseButtonDsbld ? 'btnDsbld' : ''"
              class="qty-btn"
              src="/assets/images/product/minus.svg"
              alt=""
            />
            <span class="qty-value">{{ this.selectedAmount }}</span>
            <img
              (click)="this.increaseAmount()"
              [class]="this.isIncreaseButtonDsbld ? 'btnDsbld' : ''"
              class="qty-btn"
              src="/assets/images/product/plus.svg"
              alt=""
            />
          </div>
        </div>
    </div>

    <div *ngIf="this.variations.length > 0" style="width: 95%; margin: auto; background-color: white; margin-top: 10px; border-radius: 10px; padding: 10px;">
        <div *ngIf="this.colors.length">
            <p style="font-weight: bold; width: 80%; display: inline-block;">Избери цвят: <span style="color: #0A69EB;">{{ this.selectedColor }}</span></p>
            <div>
                <img *ngFor="let variation of this.filteredVariations" (click)="this.selectItem(variation.uuid)" class="rounded-circle" [style]="(variation.uuid == this.selectedItemUUID) ? 'border: 2px solid #0A69EB; padding: 3px; height: 40px; width: 40px; display: inline-block; margin: 10px;' : ' height: 40px; width: 40px; display: inline-block; margin: 10px;'" [src]="this.variationImageURL(variation.uuid)"/>
            </div>
        </div>
        <p  *ngIf="this.sizes.length" style="font-weight: bold; width: 80%; display: inline-block;">Избери размер:</p>
        <br>
        <span *ngIf="this.colors.length">
            <span *ngFor="let size of this.filteredSizes" [style]="(size.uuid == this.selectedSizeUUID) ? 'border: 1px solid #0A69EB; margin-right: 10px; padding: 5px; width: fit-content; height: 30px; background-color: #E4F2FE; font-weight: 700; text-align: center; border-radius: 10px;' : 'margin-right: 10px; padding: 5px; width: fit-content; height: 30px; background-color: #E9EBF0; font-weight: 700; text-align: center; border-radius: 10px;'" (click)="this.selectSize(size.uuid)">{{ size.value }}</span>
        </span>
        <span *ngIf="!this.colors.length">
            <span *ngFor="let size of this.sizes"  [style]="(size.uuid == this.selectedSizeUUID) ? 'border: 1px solid #0A69EB; margin-right: 10px; padding: 5px; width: fit-content; height: 30px; background-color: #E4F2FE; font-weight: 700; text-align: center; border-radius: 10px;' : 'margin-right: 10px; padding: 5px; width: fit-content; height: 30px; background-color: #E9EBF0; font-weight: 700; text-align: center; border-radius: 10px;'"  (click)="this.selectSize(size.uuid)" style="margin-right: 10px; padding: 5px; width: fit-content; height: 30px; background-color: #E9EBF0; font-weight: 700; text-align: center; border-radius: 10px;">{{ size.value }}</span>
        </span>

    </div>
    <div class="pricing-box">
      <p class="pricing-title">{{ this.pageDetails().pricing }}</p>

      <div *ngFor="let pricing of this.currentItem?.pricing" class="row pricing-row">
        <span class="col-5 pricing-qty">
          {{
              (pricing.quantity_to === pricing.quantity_from)
                ? this.getFullAmountLabel(pricing.quantity_from)
                : pricing.quantity_from
            }}
            <span>
            {{
                (pricing.quantity_to !== pricing.quantity_from)
                  ? ('- ' + this.getFullAmountLabel(pricing.quantity_to))
                  : ''
              }}
          </span>
        </span>
        <span [class]="(pricing.quantity_from > 1) ? 'col-5 pricing-price' : 'col-6 pricing-price'">
          <app-price
            class="pricing-row-price"
            [amount]="pricing.price_per_piece"
            layout="inline"
          >
          </app-price>
          <span class="per-piece">/бр.</span>
        </span>
        <span
          *ngIf="pricing.quantity_from > 1"
          class="bg-primary col-1 discount-badge"
        >
          {{ this.calculateDiscount(this.getPricingFor(1), pricing.price_per_piece) }}
        </span>
      </div>

      <div class="row pricing-row">
        <span class="col-5 pricing-qty">{{ 'над ' + this.maxAmountForPricing + ' броя' }}</span>

        <span class="col-6 pricing-price">
          <app-price
            class="pricing-row-price"
            [amount]="this.minPriceForPricing"
            layout="inline"
          ></app-price>
          <span class="per-piece">/бр.</span>
        </span>
      </div>
    </div>

    <div style="width: 95%; margin: auto; background-color: white; margin-top: 10px; border-radius: 10px; padding: 10px; padding-bottom: 20px;">
        <p style="font-weight: bold; width: fit-content;">{{this.pageDetails().partner}}</p>
        <div class="row">
            <img class="rounded-circle col-2" style="width: 30px; height: 30px; display: inline-block; margin-left: 5px;" [src]="this.partnerImageURL" alt="">
            <span class="col-7" style="font-weight: 700; position: relative; top: 7px;"> {{this.currentItem?.organisation?.native_name}} </span>
            <button (click)="this.goToPartner()" type="button" class="btn bg-primary col-2" >{{this.pageDetails().goToPartner}}</button>
        </div>
    </div>

    <div class="delivery-box">
      <p class="delivery-title">{{ this.pageDetails().delivery }}</p>

      <p class="delivery-free" *ngIf="this.currentItem?.organisation?.free_delivery_after_order_amount">
        {{ 'Безплатна за поръчки над ' }}
        <app-price
          class="delivery-threshold-price"
          [amount]="this.currentItem?.organisation?.free_delivery_after_order_amount || 0"
          layout="inline"
        ></app-price>
        !
      </p>

      <hr class="delivery-sep" />

      <div class="delivery-row">
        <span class="delivery-label">{{ this.pageDetails().carrier + ':' }}</span>
        <span class="delivery-value">
        <app-price
          class="delivery-fee-price"
          [amount]="this.currentItem?.organisation?.delivery_to_courier_office_price || 0"
          layout="inline"
        ></app-price>
      </span>
      </div>

      <div class="delivery-row">
        <span class="delivery-label">{{ this.pageDetails().addres + ':' }}</span>
        <span class="delivery-value">
        <app-price
          class="delivery-fee-price"
          [amount]="this.currentItem?.organisation?.delivery_to_address_price || 0"
          layout="inline"
        ></app-price>
      </span>
      </div>
    </div>

    <div style="width: 95%; margin: auto; background-color: white; margin-top: 10px; border-radius: 10px; padding: 10px;">
        <p style="display: inline-block; font-weight: bold;" role="button" aria-expanded="false" aria-controls="collapseExample">{{this.pageDetails().descrpition}}</p>
        <div (click)="this.isDescrExpanded = !this.isDescrExpanded" *ngIf="this.currentItem?.description && this.currentItem!.description.length > 250"  [@slideInOut]="this.isDescExpandedAnimationString" id="descr">
            {{ this.currentItem?.description }}
        </div>
        <div (click)="this.isDescrExpanded = !this.isDescrExpanded" *ngIf="this.currentItem?.description && this.currentItem!.description.length < 250" style="margin-top: 10px; overflow: hidden" id="descr">
            {{ this.currentItem?.description }}
        </div>
        <div  *ngIf="this.currentItem?.description && this.currentItem!.description.length > 250" style="text-align: center;">
            <img (click)="this.isDescrExpanded = !this.isDescrExpanded" [style]="this.isDescrExpanded ? 'width: 15px; height: 15px; display: inline-block; transform: rotate(-90deg)' : 'width: 15px; height: 15px; display: inline-block; transform: rotate(90deg);'" src="/assets/images/product/arrow.svg" alt="">
        </div>

    </div>

    <div style="width: 95%; margin: auto; background-color: white; margin-top: 10px; border-radius: 10px; padding: 10px;">
        <p style="font-weight: bold; width: 80%; display: inline-block;">{{this.pageDetails().specifications}}</p>
        <div *ngFor="let field of this.baseProductSpecifications" style="margin-bottom: 8px;" class="row">
            <div class="col-6">{{field.label}}</div>
            <div class="col-6" style="text-align: right; font-weight: 700;">{{field.value}}</div>
        </div>
        <div *ngFor="let attribute of this.productOptions.data" style="margin-bottom: 8px;" class="row">
            <div class="col-6">{{attribute.display_name}}</div>
            <div class="col-6" style="text-align: right; font-weight: 700;">{{this.getAttrDataLabel(attribute)}}</div>
        </div>
    </div>

    <div style="width: 95%; margin: auto; background-color: white; margin-top: 10px; border-radius: 10px; padding: 10px;">
        <p style="font-weight: bold; width: 80%; display: inline-block;">{{this.pageDetails().warranty}}</p>
        <p>{{this.getWarrantyText(this.currentItem?.guarantee_in_months || 0)}}</p>
    </div>

    <div style="width: 95%; margin: auto; background-color: white; margin-top: 10px; border-radius: 10px; padding: 10px;">
        <p style="font-weight: bold; width: 80%; display: inline-block;">{{this.pageDetails().return}}</p>
        <p>{{this.pageDetails().returnText}}</p>
    </div>

    <div style="width: 95%; margin: auto; background-color: white; margin-top: 10px; border-radius: 10px; padding: 10px;">
        <p style="font-weight: bold;">Ревюта</p>
        <div class="row">
            <div  class="col-8">
                <span style="margin-right: 5px; position: relative; top: -3px;">{{this.toFixed(currentItem?.ratingAvgValue || 0, 2) + ' / 5'}}</span>
                <ngb-rating (click)="this.goToReviews()" [readonly]="true" style="position: relative;" [rate]="this.currentItem?.ratingAvgValue || 0" [max]="5">
                    <ng-template let-fill="fill" let-index="index">
                        <span class="star" [class.filled]="fill === 100">&#9733;</span>
                    </ng-template>
                </ngb-rating>
                <span style="margin-left: 5px; position: relative; top: -3px;">{{ "("+ (this.currentItem?.ratings?.data?.length ||  0) +")"}}</span>
            </div>
            <button type="button" class="btn bg-primary col-3" style="font-size: 13px;" (click)="this.goToReviews()">Виж всички</button>
        </div>
        <hr style="width: 90%; margin: auto; border: 1px solid #F5F7F8; opacity: 1; margin-top: 10px; margin-bottom: 10px;">
        <p style="color: #7A7A7A; margin-top: 20px;" *ngIf="!this.currentItem?.ratings?.data?.length">Бъди първият, който пише ревю!</p>
        <div *ngIf="this.review">
            <div class="row">
                <div class="col-2">
                    <img class="rounded-circle" style="width: 40px; height: 40px; display: inline-block; margin-top: 10px;" [src]="review?.user!.userImage || '/assets/images/shared/default-user-icon.png'"/>
                </div>
                <div class="col-6">
                    <p style="margin-bottom: 0px; position: relative; top: 7px;"> {{this.userName(review)}}</p>
                    <p style="margin-top: 5px; font-size: 10px; color: #ADAFBB;"> {{ this.date(review) }}</p>
                </div>
                <div class="col-4" style="position: relative; top: 7px;">
                    <ngb-rating [max]="5" [rate]="review.rating">
                        <ng-template let-fill="fill" let-index="index">
                            <i class="bi-star{{fill === 100 ? '-fill filled-rating' : ''}} rating" [class.filled]="fill === 100" [class.low]="index < 3"></i>
                        </ng-template>
                    </ngb-rating>
                </div>
            </div>
            <p style="margin-top: 7px; width: 90%; margin: auto;">
                {{ review.review }}
            </p>
        </div>
    </div>

    <div *ngIf="this.productsForCategory.data.length">
      <p class="cards-title">Подобни продукти</p>

      <div class="cards-scroll">
        <div class="cards-row">
          <div
            class="product-card"
            [matBadge]="product.is_in_group ? 'Групова поръчка' : ''"
            matBadgeColor="warn"
            matBadgePosition="before"
            (click)="this.openItem(product.uuid)"
            *ngFor="let product of this.productsForCategory.data"
          >
            <img
              class="card-img"
              [src]="getProductImageUrl(product.uuid) || '/assets/images/shared/logo.jpg'"
              alt=""
            />

            <p class="card-name">{{ product.name }}</p>

            <ngb-rating [readonly]="true" [max]="5" [(rate)]="product.ratingAvgValue!">
              <ng-template let-fill="fill" let-index="index">
                <i class="bi-star{{fill === 100 ? '-fill' : ''}} rating"
                   [class.filled]="fill === 100"
                   [class.low]="index < 3">
                </i>
              </ng-template>
            </ngb-rating>
            <span class="card-reviews">{{ ' (' + product.ratings!.data.length + ')' }}</span>

            <div class="card-price" *ngIf="getCardPrice(product) as price">
              <app-price class="card-price-value" [amount]="price" layout="stack"></app-price>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div *ngIf="this.productsForDifferentCategory?.data?.length">
      <p class="cards-title">Купи с</p>

      <div class="cards-scroll">
        <div class="cards-row">
          <div
            class="product-card"
            [matBadge]="product.is_in_group ? 'Групова поръчка' : ''"
            matBadgeColor="warn"
            matBadgePosition="before"
            (click)="this.openItem(product.uuid)"
            *ngFor="let product of this.productsForDifferentCategory.data"
          >
            <img
              class="card-img"
              [src]="(this.differentCategoryProductImage(product.uuid)) ? this.differentCategoryProductImage(product.uuid) : '/assets/images/shared/logo.jpg'"
              alt=""
            />

            <p class="card-name">{{ product.name }}</p>

            <div class="card-rating">
              <ngb-rating [readonly]="true" [max]="5" [(rate)]="product.ratingAvgValue!">
                <ng-template let-fill="fill" let-index="index">
                  <i
                    class="bi-star{{ fill === 100 ? '-fill' : '' }} rating"
                    [class.filled]="fill === 100"
                    [class.low]="index < 3"
                  ></i>
                </ng-template>
              </ngb-rating>

              <span class="card-reviews">{{ ' (' + (product?.ratings?.data?.length || 0) + ')' }}</span>
            </div>

            <div class="card-price" *ngIf="getCardPrice(product) as price">
              <app-price class="card-price-value" [amount]="price" layout="stack"></app-price>
            </div>
          </div>
        </div>
      </div>
    </div>
</div>

<div style="box-shadow: 0px -3px 5px #f5f7f8;position: fixed; bottom: 0; width: 100%; height: 10vh; background-color: white; margin: 0px;" class="row justify-content-around">
    <button [matBadge]="this.groupTime ? this.groupTime : ''" matBadgeColor="warn"  type="button" class="btn bg-primary col-5" style="font-size: 12px; height: 48px; position: relative; top: 2vh;" (click)="this.createGroup(login)">
        {{ this.groupTime ? "Групова поръчка" : "Създай група" }}
        <br>
        <span *ngIf="this.currentItem" style="font-size: 10px;"> {{ 'Спести до ' + this.calculateDiscount(this.getPricingFor(1), this.currentItem!.pricing[this.currentItem!.pricing.length - 1].price_per_piece) }}</span>
    </button>
    <button type="button" class="btn btn-primary col-5" style="font-size: 12px; height: 48px; position: relative; top: 2vh;" (click)="this.cart(login)">
        Добави в количка
        <br>
      <app-price
        class="product-btn-price"
        [amount]="cartTotalPrice()"
        layout="inline"
      >
      </app-price>
    </button>
</div>


<ng-template #login let-modal>
    <div style="text-align: center;">
        <img src="/assets/images/account/image-login.png" alt="" style="height: 140px; width: 160px; margin-top: 30px; margin-bottom: 20px;"> <br>
        <p style="font-weight: bold; margin-top: 7px;">Влез в профила си за да продължиш</p>
    </div>
    <div *ngIf="!this.goToMobileApp" class="row" style="margin-top: 25px; margin-bottom: 15px;">
        <div class="col-6" style="text-align: center;">
            <button class="btn btn-primary" style="border-color: transparent; width: 90%; background-color: #E4F2FE; color: #0A69EB" mat-button (click)="this.registration(modal)">Регистрация</button>
        </div>
        <div class="col-6" style="text-align: center;">
            <button class="btn btn-primary" style="width: 90%;"  mat-button (click)="this.loginNavigation(modal)">Влез</button>
        </div>
    </div>
    <div *ngIf="this.goToMobileApp" class="row" style="margin-top: 25px; margin-bottom: 15px;">
        <div class="col-12" style="text-align: center;">
            <button class="btn btn-primary" style="border-color: transparent; width: 90%; background-color: #E4F2FE; color: #0A69EB" mat-button (click)="this.goToGooglePlay()">Свалете приложението</button>
        </div>
    </div>
  </ng-template>

<ng-template #carousel let-modal>
  <div class="modal-header fullscreen-gallery-header">
    <button
      type="button"
      class="btn-close fullscreen-gallery-close"
      aria-label="Close"
      (click)="modal.dismiss('Cross click')"
    ></button>
  </div>

  <div class="modal-body fullscreen-gallery-body">
    <ngb-carousel
      *ngIf="this.productImages.data.length"
      #carouseltoggleGallery
      [activeId]="this.getActiveIdForImageCarousel()"
      [interval]="0"
      [showNavigationArrows]="false"
      [showNavigationIndicators]="true"
      class="carousel slide carousel-fade fullscreen-gallery-carousel"
      data-interval="false"
      data-touch="true"
      data-ride="carousel"
    >
      <ng-template
        ngbSlide
        *ngFor="let image of this.productImages.data; let i = index"
        id="{{ i }}"
      >
        <div class="fullscreen-gallery-slide">
          <img
            class="fullscreen-gallery-image"
            [src]="image.original.url"
            alt="Product image"
            loading="eager"
            decoding="async"
            (touchstart)="posIni = $event.changedTouches[0].pageX"
            (touchend)="move($event.changedTouches[0].pageX, carouseltoggleGallery)"
          />
        </div>
      </ng-template>
    </ngb-carousel>
  </div>
</ng-template>
